import { DialogTitle } from '@headlessui/react';
import PropTypes from 'prop-types';
import Modal from '../../../../shared/Modal/Modal';
import ProductionOrderAddressModalWrapper from './ProductionOrderAddressModalWrapper';

function ProductionOrderAddressModal({
  account,
  currentAddress = null,
  handleCloseModal,
  open,
  partnerLocation,
  productionOrderId,
  refetch = null,
}) {
  return (
    <Modal open={open} setOpen={handleCloseModal} size="2xl" zdex={999}>
      <div>
        <div className="text-center">
          <DialogTitle
            as="h2"
            className="font-semibold text-2xl text-rcgray-900 capitalize leading-6"
          >
            Edit shipping address
          </DialogTitle>
        </div>
      </div>
      <div className="mt-4">
        <ProductionOrderAddressModalWrapper
          account={account}
          address={currentAddress}
          handleCloseModal={handleCloseModal}
          partnerLocation={partnerLocation}
          productionOrderId={productionOrderId}
          refetch={refetch}
        />
      </div>
    </Modal>
  );
}

ProductionOrderAddressModal.propTypes = {
  account: PropTypes.shape({}),
  currentAddress: PropTypes.shape({}),
  handleCloseModal: PropTypes.func.isRequired,
  open: PropTypes.bool.isRequired,
  partnerLocation: PropTypes.shape({}),
  productionOrderId: PropTypes.string.isRequired,
  refetch: PropTypes.func,
};

export default ProductionOrderAddressModal;
